import clsx from "clsx";
import switchButtonsStyles from "./SwitchButtons.styles";
import { Box, Button } from "@material-ui/core";
import { SwitchButtonProps } from "../../../models/interfaces";

interface CustomProps {
  primaryButton: SwitchButtonProps;
  secondaryButton: SwitchButtonProps;
  primaryButtonActive: boolean;
  primaryButtonDisabled: boolean;
  secondaryButtonDisabled: boolean;
  hidePrimaryButton?: boolean;
}

function SwitchButtons(props: CustomProps) {
  const classes = switchButtonsStyles();

  if (props.hidePrimaryButton) {
    return (
      <Box className={classes.buttonsContainer}>
        <Button
          disabled={props.secondaryButtonDisabled}
          className={classes.activeButton}
          onClick={() => {
            props.secondaryButton.onClick();
          }}
        >
          {props.secondaryButton.text}
        </Button>
      </Box>
    );
  }

  return (
    <Box className={classes.buttonsContainer}>
      <Button
        disabled={props.primaryButtonDisabled}
        className={clsx({
          [classes.activeButton]: props.primaryButtonActive,
          [classes.inactiveButton]: !props.primaryButtonActive,
        })}
        onClick={() => {
          props.primaryButton.onClick();
        }}
      >
        {props.primaryButton.text}
      </Button>
      <Button
        disabled={props.secondaryButtonDisabled}
        className={clsx({
          [classes.activeButton]: !props.primaryButtonActive,
          [classes.inactiveButton]: props.primaryButtonActive,
        })}
        onClick={() => {
          props.secondaryButton.onClick();
        }}
      >
        {props.secondaryButton.text}
      </Button>
    </Box>
  );
}

export default SwitchButtons;
